const ICONS = {
  smile: <><circle cx="12" cy="12" r="9"/><path d="M8 14a4.5 4.5 0 0 0 8 0M8.5 9h.01M15.5 9h.01"/></>,
  raid: <><circle cx="12" cy="12" r="7"/><circle cx="12" cy="12" r="2"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/></>,
  chat: <><path d="M4 5h16v11H9l-5 4z"/><path d="M8 9h8M8 12h5"/></>,
  practice: <><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="4"/><path d="m17.5 6.5 2-2M18.5 3.5l2 2"/></>,
  decks: <><rect x="4" y="5" width="12" height="15" rx="2"/><path d="M8 2h10a2 2 0 0 1 2 2v13M8 9h4M8 13h4"/></>,
  tetris: <><path d="M4 4h6v6H4zM14 4h6v6h-6zM9 14h6v6H9z"/><path d="M7 10v4h5M17 10v4h-5"/></>,
  notice: <><path d="m4 13 11-5v8L4 11z"/><path d="M15 9l4-2v10l-4-2M6 13l1 6h4l-2-7"/></>,
  settlement: <><path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/><path d="m3 7 6-4 6 5 6-4"/></>,
  members: <><circle cx="9" cy="8" r="3"/><circle cx="17" cy="9" r="2.5"/><path d="M3 20c0-4 2.5-7 6-7s6 3 6 7M14 14c3.5 0 6 2 6 6"/></>,
  management: <><path d="M12 3 4 7v5c0 5 3.3 8 8 9 4.7-1 8-4 8-9V7z"/><circle cx="12" cy="12" r="2.5"/><path d="M12 7.5v2M12 14.5v2M7.5 12h2M14.5 12h2"/></>,
  profile: <><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="11" r="2.5"/><path d="M5.5 17c.5-2 1.8-3 3.5-3s3 1 3.5 3M14 9h4M14 13h4"/></>,
  nikke: <><path d="M7 20v-3a5 5 0 0 1 10 0v3"/><circle cx="12" cy="9" r="4"/><path d="M8 8 5 5M16 8l3-3M9 4l3-2 3 2"/></>,
  season: <><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M7 2v6M17 2v6M3 10h18M8 14h3v3H8z"/></>,
  bridge: <><path d="M4 17h5v4H4zM15 3h5v4h-5zM9 19h3a5 5 0 0 0 5-5v-3M15 5h-3a5 5 0 0 0-5 5v3"/><path d="m5 11 2 2 2-2M15 13l2-2 2 2"/></>,
  platform: <><path d="M4 20V8l8-5 8 5v12M8 20v-7h8v7M2 20h20"/></>,
  capture: <><rect x="3" y="5" width="18" height="15" rx="2"/><path d="m8 5 1.5-2h5L16 5"/><circle cx="12" cy="12.5" r="4"/></>,
  memo: <><path d="M5 3h14a2 2 0 0 1 2 2v11l-5 5H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/><path d="M16 21v-5h5M7 8h10M7 12h7"/></>,
  refresh: <><path d="M20 7v5h-5M4 17v-5h5"/><path d="M6.1 8A7 7 0 0 1 18 6l2 6M17.9 16A7 7 0 0 1 6 18l-2-6"/></>,
  details: <><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7h.01"/></>,
  plan: <><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18M10 9v11"/><path d="M5.5 12.5h2.5M5.5 16h2.5"/><path d="m12.3 14.2 1.9 1.9 3.5-4"/></>,
  edit: <><path d="M4 20h4l11-11-4-4L4 16z"/><path d="m13.5 6.5 4 4"/></>,
  save: <><path d="M5 3h12l2 2v16H5z"/><path d="M8 3v6h8V3M8 21v-7h8v7"/></>,
  pin: <><path d="m16 3 5 5-3 1-4 4v4l-2 2-7-7 2-2h4l4-4zM8 16l-5 5"/></>,
  plus: <path d="M12 5v14M5 12h14"/>,
  close: <path d="m6 6 12 12M18 6 6 18"/>,
  trash: <><path d="M4 7h16M9 7V4h6v3M7 7l1 14h8l1-14M10 11v6M14 11v6"/></>,
  chevronLeft: <path d="m15 18-6-6 6-6"/>,
  chevronRight: <path d="m9 18 6-6-6-6"/>,
  chevronUp: <path d="m6 15 6-6 6 6"/>,
  chevronDown: <path d="m6 9 6 6 6-6"/>,
  logout: <><path d="M10 5H5v14h5M14 8l4 4-4 4M18 12H9"/></>,
};

export function DororaidIcon({ name, size = 24, className = '', title = '' }) {
  const content = ICONS[name] || ICONS.raid;
  return (
    <svg className={`dororaid-icon ${className}`.trim()} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden={title ? undefined : true} role={title ? 'img' : undefined}>
      {title ? <title>{title}</title> : null}
      {content}
    </svg>
  );
}
